import { Box } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { ReactElement } from 'react';
import { tokens } from '@synergy/theme-palo';

const c = tokens.color;

/**
 * The best bid of an address. A badge, not tinted text: as plain blue words
 * the best bid read as part of the name (#2185).
 */
export const PaloBestOfferBadge = (): ReactElement => (
    <Box
        component="span"
        sx={{
            padding: '1px 7px',
            borderRadius: '10px',
            fontSize: '10.5px',
            fontWeight: 700,
            letterSpacing: '.03em',
            textTransform: 'uppercase',
            color: c.inkInvert,
            backgroundColor: c.accent,
            whiteSpace: 'nowrap',
        }}
    >
        <FormattedMessage id="app.inquiries.detail.bestOffer" />
    </Box>
);
